import React, {useEffect, useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { push } from 'connected-react-router';

// Axios Cache Instance
import {axiosCached} from "../../../../redux/auth/authService";

import SkipPreviousIcon from '@mui/icons-material/SkipPrevious';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import SkipNextIcon from '@mui/icons-material/SkipNext';
import NoImage from "../../../../styles/images/NoProjectImageFound.jpg";
import * as ParameterUtilities from "../../../../utilities/ParameterUtilities";

import {
    styled,
    useTheme,
    Card,
    CardContent,
    CardMedia,
    CardActionArea,
    Divider,
    IconButton,
    Typography,
} from '@mui/material';

const PREFIX = 'NavigationCard';

const classes = {
    root: `${PREFIX}-root`,
    actionArea: `${PREFIX}-actionArea`,
    details: `${PREFIX}-details`,
    content: `${PREFIX}-content`,
    cover: `${PREFIX}-cover`,
    loadingContainer: `${PREFIX}-loadingContainer`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled(Card)((
    {
        theme
    }
) => ({
    [`&.${classes.root}`]: {
        height: '100px',
        width: '100%',
        overflow: 'hidden',
        display: 'inline-flex',
        boxShadow: 'none'
    },

    [`& .${classes.actionArea}`]: {
        width: '100%',
        height: '100%',
        padding: '4px'
    },

    [`& .${classes.details}`]: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        width: 'calc(100% - 96px)',
    },

    [`& .${classes.content}`]: {
        width: 'calc(100% - 16px)',
        height: 'calc(100% - 16px)',
        padding: '8px'
    },

    [`& .${classes.cover}`]: {
        position: 'absolute',
        top: '0px',
        right: '0px',
        width: '80px',
        height: 'calc(100% - 16px)',
        margin: '8px',
        backgroundColor: 'grey'
    },

    [`& .${classes.loadingContainer}`]: {
        width: '100%',
        height: '100%',
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        margin: '0px',
        color: 'white'
    }
}));

export default function NavigationCard({ data, cardKeyField, viewStaged }) {

    // const theme = useTheme();
    const dispatch = useDispatch();

    // App State
    const activeRoute = useSelector(state => state.router.location.pathname);
    const config = useSelector(state => state.config);
    const auth = useSelector(state => state.auth);

    // Component State
    const [cardData, setCardData] = useState(null);
    const [image, setImage] = useState(null);

    useEffect( () => {
        // console.log('ProjectCard: UseEffect, [data]');
        // console.log(data);

        // Set card data
        setCardData({
            title: getTitle(data.title),
            subheader: getSubheader(data.subtitle)
            // subtitle: data.subtitle, // Used to link to correct details page i.e. route var
            // attribute1Title: getAttribute1Title(data.attribute1title),
            // attribute1Value: getAttribute1Value(data.attribute1),
            // attribute2Title: getAttribute1Title(data.attribute2title),
            // attribute2Value: getAttribute2Value(data.attribute2),
            // narrative: data.description
        });

        const url = config.data.authentication.api + 'DBQuery';

        axiosCached.get(url, {
            params: {
                db: config.data.authentication.apiSource,
                table: 'ProjectImage{0}'.format(viewStaged ? 'Staged': ''),
                fields: "SMImage",
                where: "Identifier eq '" + data.subtitle + "'"
            },
            useCache: true
        })
            .then(function (response) {
                let defaultImage = response.data.find(i => {
                    return i.defaultImage === true
                })
                if (!defaultImage) {
                    defaultImage = response.data[0];
                }
                const imageBase64 = 'data:image/png;base64,' + defaultImage.smImage;
                setImage(imageBase64);
            })
            .catch(function (error) {
                setImage(NoImage);
            });
    }, [data]);

    function getTitle(title) {
        // TODO: Add some scrub logic?
        const cardTitle = title ? title : 'No data available';  // Title
        return cardTitle;
    }

    function getSubheader(subheader) {
        // TODO: Add some scrub logic?
        const cardSubheader = subheader ? subheader : 'No data available';  // Subheader
        return cardSubheader;
    }

    function handleClick() {
        // console.log('PUSHING ------>  /details?id={0}'.format(data.id));

        // Parse out the URL/Tab and then push on the id
        const currentRoute = ParameterUtilities.trimParams(activeRoute);
        // console.log('current route" ' + currentRoute);

        dispatch(push('{0}?id={1}'.format(currentRoute, data[cardKeyField])));
    }

    return (
        <React.Fragment>
            {cardData &&
                <React.Fragment>
                    <Root className={classes.root} onClick={handleClick}>
                        <CardActionArea className={classes.actionArea}>
                            <div className={classes.details}>
                                <CardContent className={classes.content}>
                                    <Typography variant="subtitle1" gutterBottom>
                                        {cardData.title}
                                    </Typography>
                                    <Typography variant="caption" color="textSecondary">
                                        {cardData.subheader}
                                    </Typography>
                                </CardContent>
                            </div>
                            {image &&
                            <CardMedia
                                className={classes.cover}
                                image={image}
                                title="Live from space album cover"
                            />
                            }
                            {!image &&
                            <div className={classes.cover}>
                                {/*<CircularProgress className={classes.cardMediaProgress}/>
                                            TODO: REPLACE WITH STATIC LOADING IMAGE SO BROWSER DOESNT HAVE TO WORK ON ANI */}
                                <div className={classes.loadingContainer}>
                                    <Typography variant="subtitle2" gutterBottom style={{textAlign: 'center'}}>
                                        LOADING...
                                    </Typography>
                                </div>
                            </div>
                            }
                        </CardActionArea>
                    </Root>
                    <Divider light />
                </React.Fragment>
            }
        </React.Fragment>
    );
}
